export default {
	profile:              false,
	currentPassword:      '',
	newPassword:          '',
	repeatPassword:       '',
	changePasswordErrors: [],
	subscription:         {}
}
;
